(function () {
    'use strict';

    angular
        .module('ipmApp')
        .controller('SubmitPageHAQBriefReviewController', SubmitPageHAQBriefReviewController);

        SubmitPageHAQBriefReviewController.$inject = ['$state', 'briefReviewEntity', 'HAQBriefReviewWorkflowService', 'signature', 'ClearLocalStorageService'];

    function SubmitPageHAQBriefReviewController($state, briefReviewEntity, HAQBriefReviewWorkflowService, signature, ClearLocalStorageService) {
        var vm = this;
        vm.isSaving = false;
        vm.briefReviewEntity = briefReviewEntity;
        vm.mostRecentSignature = signature ? signature : null;
        vm.isShowSignaturePad = true;
        vm.signatureId = null; // if signatureId is not null used mostRecent signature
        init();

        function init() {
            ClearLocalStorageService.clearTimeSpent(); // clear & stop time spent
            vm.isShowSignaturePad = vm.mostRecentSignature && vm.mostRecentSignature.id && vm.mostRecentSignature.data ? false : true;
        }

        vm.onChangeSignature = function(data) {
            vm.signatureString = data;
        }

        vm.finishBriefReview = function() {
            vm.isSaving = true;
            if (!vm.signatureString && !vm.isShowSignaturePad && vm.mostRecentSignature && vm.mostRecentSignature.id) {
                vm.signatureId = vm.mostRecentSignature.id;
            }
            HAQBriefReviewWorkflowService.finishBriefReview({ haqEvaluationId: vm.briefReviewEntity.haqEvaluationId, signatureString: vm.signatureString, signatureId: vm.signatureId }).then(function() {
                $state.go('home');
            }, function errorSave(error) {
                onSaveError(error);
            });
        }

        vm.checkSignature = function() {
            if (vm.isShowSignaturePad) {
                return !vm.signatureString;
            }
            return !(vm.mostRecentSignature && vm.mostRecentSignature.id);
        }

        function onSaveError(error) {
            vm.isSaving = false;
            if (error.status === 400) {
                ClearLocalStorageService.clearTimeSpent();
                $state.go('home');
            }
        }
    }
})();
